const ForeignWorkerQuery = (id) => {
  return `
    query {
      deleteForeignWorker(id: "${id}")
    } 
    `;
};

export default ForeignWorkerQuery;
